<template>
  <div class="page-container">
    <div class="text-center py-6 pt-10" v-show="!isLoaded">
      <font-awesome-icon class="text-gray-500" :icon="['fas', 'circle-notch']" transform="grow-6" spin />
    </div>
    <div v-show="isLoaded">
      <div class="grid md:grid-cols-3 sm:grid-cols-2 xs:grid-cols-1 py-2">
        <div class="float-left py-2 px-2">
          <div class="p-6 h-32 xl:h-auto bg-blue-100 rounded-md">
            <div class="float-right">
              <button v-if="store.state.user.permissions.includes('USER.TOPUP_CASH')" @click="toggleCashTopupModal"
                class="sm:ml-auto inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                type="button">
                <font-awesome-icon class="mr-2" :icon="['far', 'coins']" />
                <span>{{ $t("messages.player.walletInfo.topupCash") }}</span>
              </button>
            </div>
            <div>
              {{ $t("messages.player.walletInfo.validBalance") }}
            </div>
            <span class="block text-4xl mt-1">
              {{
                walletInfo.availableBalance
                  ? parseFloat(walletInfo.availableBalance).toLocaleString(
                    "en",
                    {
                      useGrouping: true,
                      minimumFractionDigits: 2,
                    }
                  )
                  : Number(0).toFixed(2)
              }}
            </span>
          </div>
        </div>

        <div class="float-left py-2 px-2">
          <div class="p-6 h-32 xl:h-auto bg-gray-100 rounded-md">
            <div class="">
              {{ $t("messages.player.walletInfo.totalHoldBalance") }}
              <!-- <div class="float-right">
                <button
                  v-if="Number(walletInfo.holdBalance) !== 0"
                  @click="onClearTotalHoldBalance"
                  class="sm:ml-auto inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  type="button"
                >
                  <font-awesome-icon class="mr-2" :icon="['far', 'eraser']" />
                  <span>{{ $t("messages.player.walletInfo.clear") }} </span>
                </button>
              </div> -->
            </div>
            <span class="block text-4xl mt-1">
              {{
                walletInfo.holdBalance
                  ? parseFloat(walletInfo.holdBalance).toLocaleString("en", {
                    useGrouping: true,
                    minimumFractionDigits: 2,
                  })
                  : Number(0).toFixed(2)
              }}
            </span>
          </div>
        </div>
        <div class="float-left py-2 px-2">
          <div class="p-6 h-32 xl:h-auto bg-green-100 rounded-md">
            <div class="">
              {{ $t("messages.player.walletInfo.totalBalance") }}
            </div>
            <span class="block text-4xl mt-1">
              {{
                walletInfo.totalBalance
                  ? parseFloat(walletInfo.totalBalance).toLocaleString("en", {
                    useGrouping: true,
                    minimumFractionDigits: 2,
                  })
                  : Number(0).toFixed(2)
              }}
            </span>
          </div>
        </div>
        <div class="float-left py-2 px-2">
          <div class="p-6 h-32 xl:h-auto bg-purple-100 rounded-md">
            <div class="">
              <p>{{ $t("messages.player.walletInfo.totalDeposit") }}</p>
            </div>
            <span class="block text-4xl mt-1">
              {{
                walletInfo.cashTopup
                  ? parseFloat(walletInfo.cashTopup).toLocaleString("en", {
                    useGrouping: true,
                    minimumFractionDigits: 2,
                  })
                  : Number(0).toFixed(2)
              }}
            </span>
          </div>
        </div>

        <div class="float-left py-2 px-2">
          <div class="p-6 h-32 xl:h-auto bg-red-100 rounded-md">
            <div class="">
              {{ $t("messages.player.walletInfo.totalWithdraw") }}
              <!-- <b> {{ $t("messages.player.walletInfo.cash") }}</b> -->
            </div>
            <span class="block text-4xl mt-1">
              {{
                walletInfo.cashWithdraw
                    ? parseFloat(walletInfo.cashWithdraw).toLocaleString("en", {
                      useGrouping: true,
                      minimumFractionDigits: 2,
                    })
                    : Number(0).toFixed(2)
              }}
            </span>
          </div>
        </div>
        <div class="float-left py-2 px-2">
          <div class="p-6 h-32 xl:h-auto bg-gray-100 rounded-md">
            <div class="float-right">
              <button v-if="store.state.user.permissions.includes('USER.TOPUP_CASH')" @click="toggleAdjustTurnoverLeftModal"
                      class="sm:ml-auto inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                      type="button">
                <font-awesome-icon class="mr-2" :icon="['far', 'coins']" />
                <span>{{ $t("messages.player.walletInfo.adjustTurnOver") }}</span>
              </button>
            </div>
            <div class="">
              {{ $t("messages.player.walletInfo.turnoverLeft") }}
              <!-- <b> {{ $t("messages.player.walletInfo.cash") }}</b> -->
            </div>
            <span class="block text-4xl mt-1">
              {{
                walletInfo.turnoverLeft
                    ? parseFloat(walletInfo.turnoverLeft).toLocaleString("en", {
                      useGrouping: true,
                      minimumFractionDigits: 2,
                    })
                    : Number(0).toFixed(2)
              }}
            </span>
          </div>
        </div>

      </div>
      <!-- <div class="float-right">
        <button
          @click="toggleCashTopupModal"
          class="sm:ml-auto inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          type="button"
        >
          <font-awesome-icon class="mr-2" :icon="['far', 'coins']" />
          <span>{{ $t("messages.player.walletInfo.topupCash") }} </span>
        </button>
      </div> -->
      <div class="sm:px-2 md:px-4 pt-6">
        <div>
          <h2 class="text-2xl font-bold pb-6">Player Payment MemberID</h2>
        </div>

        <div
            v-if="paymentUserList && paymentUserList.length"
            class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3"
        >
        <div
              v-for="(item, index) in paymentUserList"
              :key="index"
              class="p-3 rounded-md bg-gray-50 border border-gray-200"
        >
            <div class="font-semibold">
              {{ item.Payment.name }}
            </div>

            <div class="text-sm text-gray-700 break-all">
              {{
                item.memberId
              }}
            </div>
          </div>
        </div>


      </div>
      <div class="clear-both"></div>


      <div class="sm:px-2 md:px-4 pt-6">
        <div>
          <h2 class="text-2xl font-bold pb-6">Player Activity Logs</h2>
          <div class="shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg">
            <DataTable :columns="columns" :data="dataRows" @showDetailTable="showDetailDialog"
              :isLoaded="isActivityLoaded" />
            <Pagination v-model:config="pageConfig" />
          </div>
        </div>

      </div>

      <div class="clear-both"></div>
    </div>
    <TransitionRoot as="template" :show="topupOpen">
      <Dialog as="div" static class="fixed z-10 inset-0 overflow-y-auto" @close="topupOpen = false" :open="topupOpen">
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
            leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div
              class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6">
              <div>
                <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                  <font-awesome-icon class="text-green-600" :icon="['far', 'coins']" transform="grow-2" />
                </div>
                <div class="mt-3 text-center sm:mt-5">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                    {{ $t("messages.player.walletInfo.topupCredit") }}
                    <!-- <small class="text-gray-400">{{ userInfo.username }}</small> -->
                  </DialogTitle>
                  <div class="mt-8 pb-2 text-left">
                    <div class="mt-1">
                      <input type="text" v-model="topupAmount" name="credit-amount" id="creditAmount"
                        class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        placeholder="Credit Amount" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <button type="button" :disabled="isWorking" @click="toppupCredit"
                  class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm">
                  {{ $t("messages.player.walletInfo.topup") }}
                </button>
                <button type="button" @click="toggleCreditTopupModal"
                  class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                  ref="cancelButtonRef">
                  {{ $t("messages.player.walletInfo.cancel") }}
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>

    <TransitionRoot as="template" :show="topupCashOpen">
      <Dialog as="div" static class="fixed z-10 inset-0 overflow-y-auto" @close="topupOpen = false" :open="topupOpen">
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
            leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div
              class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6">
              <div>
                <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                  <font-awesome-icon class="text-green-600" :icon="['far', 'coins']" transform="grow-2" />
                </div>
                <div class="mt-3 text-center sm:mt-5">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                    {{ $t("messages.player.walletInfo.topupCash") }}
                    <!-- <small class="text-gray-400">{{ userInfo.username }}</small> -->
                  </DialogTitle>
                  <div class="mt-8 pb-2 text-left">
                    <div class="mt-1">
                      <input type="text" v-model="topupAmount" name="cash-amount" id="cashAmount"
                        class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md my-2"
                        :placeholder="$t('messages.player.walletInfo.creditAmount')
                          " />
                      <input type="text" v-model="topupNote" maxlength="100" name="cash-note" id="cashNote"
                        class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md my-2"
                        :placeholder="$t('messages.player.walletInfo.creditNote')
                          " />
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <button type="button" :disabled="isWorking" @click="toppupCash"
                  class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
                  v-if="store.state.user.permissions.includes('USER.TOPUP_CASH')">
                  {{ $t("messages.player.walletInfo.topup") }}
                </button>
                <button type="button" @click="toggleCashTopupModal"
                  class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                  ref="cancelButtonRef">
                  {{ $t("messages.player.walletInfo.cancel") }}
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
    <TransitionRoot as="template" :show="adjustTurnoverLeftOpen">
      <Dialog as="div" static class="fixed z-10 inset-0 overflow-y-auto" @close="adjustTurnoverLeftOpen = false" :open="adjustTurnoverLeftOpen">
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                           leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <TransitionChild as="template" enter="ease-out duration-300"
                           enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                           enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                           leave-from="opacity-100 translate-y-0 sm:scale-100"
                           leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div
                class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6">
              <div>
                <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                  <font-awesome-icon class="text-green-600" :icon="['far', 'coins']" transform="grow-2" />
                </div>
                <div class="mt-3 text-center sm:mt-5">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                    {{ $t("messages.player.walletInfo.adjustTurnoverLeft") }}
                    <!-- <small class="text-gray-400">{{ userInfo.username }}</small> -->
                  </DialogTitle>
                  <div class="mt-8 pb-2 text-left">
                    <div class="mt-1">
                      <input type="text" v-model="adjustTurnoverLeftAmount" name="cash-amount" id="cashAmount"
                             class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md my-2"
                             :placeholder="$t('messages.player.walletInfo.creditAmount')
                          " />
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <button type="button" :disabled="isWorking" @click="onAdjustTurnoverLeft"
                        class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
                        v-if="store.state.user.permissions.includes('USER.TOPUP_CASH')">
                  {{ $t("messages.player.walletInfo.adjustTurnoverLeft") }}
                </button>
                <button type="button" @click="toggleAdjustTurnoverLeftModal"
                        class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                        ref="cancelButtonRef">
                  {{ $t("messages.player.walletInfo.cancel") }}
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
    <Toast v-model:show="toastConfig.show" :message="toastConfig.message" :success="toastConfig.success" />
  </div>
  <UserActivityLogsDetailDialog v-model:show="detailDialogModal" :form="selectedRow" @closed="fetchPageData()" />
</template>

<script>
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
  HomeIcon,
  SearchIcon,
  PhoneIcon,
} from "@heroicons/vue/solid";
import {
  Dialog,
  DialogOverlay,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { inject, onMounted, ref, watch } from "@vue/runtime-core";
import { useStore } from "vuex";
import * as dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useRoute } from "vue-router";
import DateSelector from "@/components/tools/DateSelector.vue";
import Toast from "@/components/tools/Toast.vue";
import DataTable from "@/components/tools/DataTable.vue";
import { translate } from "@/utils/tools";
import Pagination from "@/components/tools/Pagination.vue";
import UserActivityLogsDetailDialog from "@/components/dialogs/UserActivityLogsDetailDialog.vue";

dayjs.extend(localizedFormat);

export default {
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckCircleIcon,
    MailIcon,
    HomeIcon,
    SearchIcon,
    PhoneIcon,
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    DateSelector,
    Toast,
    DataTable,
    Pagination,
    translate,
    UserActivityLogsDetailDialog
  },
  setup() {
    const axios = inject("$axios");
    const store = useStore();
    const route = useRoute();
    let walletInfo = ref({});
    let topupAmount = ref(null);
    let topupNote = ref(null)
    let adjustTurnoverLeftAmount = ref(0);
    let adjustTurnoverLeftNote = ref(``)
    let isLoaded = ref(false);
    let isWorking = ref(false);
    let now = new Date();
    let topUpWithdrawInfo = ref({});
    let isLoadedDeposit = ref(false);
    const topupOpen = ref(false);
    const topupCashOpen = ref(false);
    const adjustTurnoverLeftOpen = ref(false);
    const dateSelectorRef = ref(null);
    const toastConfig = ref({
      show: false,
      message: "",
      success: false,
      warning: false
    });


    const dataRows = ref([]);
    const isActivityLoaded = ref(false);
    const detailDialogModal = ref(false);
    const selectedRow = ref({});
    const paymentUserList = ref([])

    const columns = [
      {
        label: translate("messages.activityLog.createdAt"),
        field: "createdAt",
        align: "left",
        format: (data) => dayjs(data.createdAt).locale("th").format("YYYY-MM-DDTHH:mm"),
      },
      {
        label: translate("messages.activityLog.action"),
        field: "action",
        align: "left",
      },
      {
        label: translate("messages.activityLog.amount"),
        field: "amount",
        align: "left",
        format: (data) => !data.amount ? '' :
          Number(data.amount / 100).toLocaleString("en", {
            useGrouping: true,
            minimumFractionDigits: 2,
          }),
      },
      {
        label: translate("messages.activityLog.actionBy"),
        field: "actorUsername",
        align: "left",
      },
      {
        label: translate("messages.activityLog.ipAddress"),
        field: "actorIp",
        align: "left",
        format: (data) => !data.actorIp ? '' :
          data.actorIp.split(",")[0].length > 16 ?
            data.actorIp.split(",")[0].substring(0, 16) : data.actorIp.split(",")[0],
      },
      // {
      //     label: translate("messages.activityLog.actionTo"),
      //     field: "affectedName",
      //     align: "left",
      // },
      {
        label: translate("messages.activityLog.logId"),
        field: "id",
        align: "left",

      },
      {
        field: "",
        sort: false,
        isButton: true,
        isRow: true,
        clickable: true,
      },
    ];
    const pageConfig = ref({
      page: 1,
      count: 0,
      pageCount: 0,
      rowsPerPage: 10,
      dataLength: 0,
    });

    const toggleCreditTopupModal = () => {
      topupOpen.value = !topupOpen.value;
    };

    const toggleCashTopupModal = () => {
      topupCashOpen.value = !topupCashOpen.value;
    };

    const toggleAdjustTurnoverLeftModal = () => {
      adjustTurnoverLeftOpen.value = !adjustTurnoverLeftOpen.value;
    };

    const toppupCredit = () => {
      isWorking.value = true;
      if (
        confirm("Topup credit for this user?") ||
        topupAmount.isNumber() ||
        topupAmount > 0
      ) {
        axios
          .post(
            process.env.VUE_APP_API_ENDPOINT +
            "/admin/api/v1/operator-admin/wallet/topup-credit",
            {
              operatorId: store.state.selectedOperator.operatorId,
              userId: route.params.id,
              amount: topupAmount.value,
            }
          )
          .then((res) => {
            isWorking.value = false;
            topupOpen.value = false;
            setTimeout(() => {
              topupAmount.value = null;
            }, 1000);
            refetch();
          })
          .catch((err) => {
            isWorking.value = false;
            console.log(err);
          });
      }
    };

    const toppupCash = () => {
      isWorking.value = true;
      if (
        confirm("Topup cash for this user?") ||
        topupAmount.isNumber() ||
        topupAmount > 0 ||
        topupNote
      ) {
        axios
          .post(
            process.env.VUE_APP_API_ENDPOINT +
            "/admin/api/v1/operator-admin/wallet/topup-cash",
            {
              operatorId: store.state.selectedOperator.operatorId,
              userId: route.params.id,
              amount: topupAmount.value,
              note: topupNote.value,
              adminId: store.state.user.id
            }
          )
          .then((res) => {
            isWorking.value = false;
            topupCashOpen.value = false;
            setTimeout(() => {
              topupAmount.value = null;
              topupNote.value = null;
            }, 1000);
            refetch();
          })
          .catch((err) => {
            isWorking.value = false;
            console.log(err);
          });
      }
    };

    const onAdjustTurnoverLeft = () => {
      isWorking.value = true;
      if (
          confirm("adjust turnoverleft for this user?") ||
          Number(adjustTurnoverLeftAmount.value) ||
          adjustTurnoverLeftAmount > 0
      ) {
        axios
            .post(
                process.env.VUE_APP_API_ENDPOINT +
                "/admin/api/v1/operator-admin/wallet/adjust-turnoverleft",
                {
                  operatorId: store.state.selectedOperator.operatorId,
                  userId: route.params.id,
                  amount: `${Number(adjustTurnoverLeftAmount.value) * 100}`,
                }
            )
            .then((res) => {
              isWorking.value = false;
              adjustTurnoverLeftOpen.value = false;
              setTimeout(() => {
                adjustTurnoverLeftAmount.value = null;
              }, 1000);
              refetch();
            })
            .catch((err) => {
              isWorking.value = false;
              console.log(err);
            });
      }
    };

    const onSearch = (e) => {
      dateSelectorRef.value.state = e;
      refetch();
      refetchTopup();
    };

    onMounted(() => {
      pageConfig.value.page = Number(route.query.page) || 1;
      pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
      refetch();
      fetchPaymentUser();
      fetchPageData();
    });

    const fetchPaymentUser = () => {
      axios
          .post(
              process.env.VUE_APP_API_ENDPOINT +
              `/admin/api/v1/be-payment/payment-user/${route.params.id}`,
              {}
          )
          .then((res) => {
            paymentUserList.value = res.data
          })
          .catch((err) => {
            console.log(err);
          });
    };

    const refetch = () => {
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/operator-admin/wallet/user/info",
          {
            operatorId: store.state.selectedOperator.operatorId,
            userId: route.params.id,
            timestamp: now.getTime(),
          }
        )
        .then((res) => {
          // const wallets = res.data.result.wallets.sort((a, b) =>
          //   a.walletTypeCode > b.walletTypeCode
          //     ? 1
          //     : b.walletTypeCode > a.walletTypeCode
          //     ? -1
          //     : 0
          // );
          // res.data.result.wallets = wallets;
          walletInfo.value = res.data.result;
          isLoaded.value = true;
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const fetchPageData = async () => {
      isActivityLoaded.value = false;
      const { page, rowsPerPage } = pageConfig.value;
      const payload = {
        operatorId: store.state.selectedOperator.operatorId,
        page: page - 1,
        limit: rowsPerPage,
        offset: page * rowsPerPage - rowsPerPage,
        sortBy: [["createdAt", -1]],
        affectedId: route.params.id,
        // affectedNameEqual: props.affectedName,
      };
      const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/user-activity-logs/list-v2`;
      const data = await axios.post(url, payload).then(({ data }) => data.result);
      dataRows.value = data;
      isActivityLoaded.value = true;
      selectedRow.value = {}
      pageConfig.value.dataLength = data.length;
      pageConfig.value = {
        ...pageConfig.value
      };
    };

    const onClearTotalHoldBalance = async () => {
      const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/internal/wallet/clear_hold_balance`;
      const payload = {
        user_id: route.params.id,
        confirm: true,
        operator_id: store.state.selectedOperator.operatorId,
      };
      try {
        const { data } = await axios.post(url, payload);

        if (data.status !== "success") {
          const errors = data.result.map(
            (element, index) => element.call_back.is_error
          );
          // all fail
          if (errors.length === data.result.length - 1) {
            toastConfig.value = {
              show: true,
              success: false,
              message:
                "Failed to clear user's holding balance, please contact admin",
              warning: false
            };
          }
          // some fail
          else {
            toastConfig.value = {
              show: true,
              success: false,
              message:
                "Some of user's holding balance cannot be cleared, please contact admin ",
              warning: false
            };
          }
        } else {
          toastConfig.value = {
            show: true,
            success: true,
            message: "Holding balance was cleared successfully!",
            warning: false
          };
        }
      } catch (error) {
        console.log(error);
      }
    };

    const showDetailDialog = async (data) => {
      detailDialogModal.value = true;
      selectedRow.value = data;
    }

    watch(() => pageConfig.value.page, fetchPageData);
    watch(() => pageConfig.value.rowsPerPage, () => {
      pageConfig.value.page = 1;
      fetchPageData();
    });

    return {
      store,
      walletInfo,
      isLoaded,
      topupOpen,
      toggleCreditTopupModal,
      toppupCredit,
      topupAmount,
      toggleCashTopupModal,
      topupCashOpen,
      isWorking,
      toppupCash,
      topUpWithdrawInfo,
      dateSelectorRef,
      onSearch,
      onClearTotalHoldBalance,
      toastConfig,
      topupNote,
      columns,
      dataRows,
      isActivityLoaded,
      fetchPageData,
      selectedRow,
      pageConfig,
      showDetailDialog,
      detailDialogModal,
      paymentUserList,
      adjustTurnoverLeftNote,
      adjustTurnoverLeftAmount,
      onAdjustTurnoverLeft,
      toggleAdjustTurnoverLeftModal,
      adjustTurnoverLeftOpen,
    };
  },
};
</script>
